import { Controller } from '@hotwired/stimulus';

// Surlignage du fragment édité du panneau de rejeu (spec §5.4, X-13).
// Posé sur le textarea du payload : dès que `value` diverge de `defaultValue`
// (la valeur servie par le serveur), un liseré warning signale que le rejeu
// partirait sur un fragment MODIFIÉ ; identique => classes retirées. Le bouton
// « Réinitialiser » est un reset natif : on écoute l'événement `reset` du form
// (émis AVANT la remise à zéro des champs, d'où le requestAnimationFrame)
// pour retirer le surlignage après le reset.
// Classes du registre warning (tokens Tailwind du dépôt), jamais de couleur brute.
const EDITED_CLASSES = ['ring-2', 'ring-warning-400', 'bg-warning-50'];

export default class extends Controller {
  connect() {
    this.onReset = () => requestAnimationFrame(() => this.refresh());
    this.element.form?.addEventListener('reset', this.onReset);
  }

  disconnect() {
    this.element.form?.removeEventListener('reset', this.onReset);
  }

  refresh() {
    const edited = this.element.value !== this.element.defaultValue;
    EDITED_CLASSES.forEach((cls) => this.element.classList.toggle(cls, edited));
  }
}
